import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = '404 - Page Not Found | iLOVEthisGAME Canada';

    // Prevent search engines from indexing 404 pages or generating sitelinks
    let metaRobots = document.querySelector('meta[name="robots"]');
    let originalRobots = metaRobots ? metaRobots.getAttribute('content') : null;

    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', 'noindex, nofollow');

    return () => {
      if (metaRobots) {
        if (originalRobots) {
          metaRobots.setAttribute('content', originalRobots);
        } else {
          metaRobots.setAttribute('content', 'index, follow');
        }
      }
    };
  }, []);

  return (
    <div className="not-found-container container">
      <div className="not-found-card text-center">
        <span className="badge-volt">404 ERROR</span>
        <h1 className="not-found-title">PAGE NOT FOUND</h1>
        <p className="not-found-desc">
          The page you are looking for has been moved, renamed, or does not exist. Let's get you back on the pitch!
        </p>
        <div className="not-found-actions">
          <Link to="/" className="btn btn-volt">Back to Home &rarr;</Link>
          <Link to="/#product-showcase" className="btn btn-outline">Shop Playermaker 2.0</Link>
          <Link to="/blog" className="btn btn-outline">Read Blog</Link>
          <Link to="/faq" className="btn btn-outline">FAQ & Support</Link>
        </div>
      </div>
    </div>
  );
}
